import React, { useState , useEffect} from 'react';
import Form from "react-bootstrap/Form";
import {Button, Row, Col} from "react-bootstrap";

function VolumePicker(props) {

    const volumePicklist = ["10", "20", "50", "100", "200", "500"];

    useEffect(() => {
    }, []);

    const handleInputChange = (e) => {
        props.setVolume(e.target.value);
    };

    const handleButtonClick = (vol) => {
        props.setVolume(vol);
    };

    return (
        <Form.Group className="mb-3">
            <Form.Label>Amount, USDT</Form.Label>
            <Row>
                <Col md={3}>
                    <Form.Control
                        type="number"
                        value={props.volume}
                        onChange={handleInputChange}
                        className="mb-2"
                        placeholder="Enter amount..."
                    />
                </Col>
                <Col md={9}>
                    <div className="d-flex">
                        {(volumePicklist.map((vol, idx) => (
                            <Button
                                key={vol}
                                variant={props.volume === vol ? "primary" : "outline-primary"}
                                active={props.volume === vol}
                                onClick={() => handleButtonClick(vol)}
                                className={idx !== (volumePicklist.length - 1) ? "w-100 border-end-0 rounded-0" : "w-100 rounded-0"}
                                style={{borderRadius: idx === 0 ? "0.375rem 0 0 0.375rem" : idx === 4 ? "0 0.375rem 0.375rem 0" : "0"}}
                            >
                                {vol}
                            </Button>
                        )))}
                    </div>
                </Col>
            </Row>
        </Form.Group>
    );
}

export default VolumePicker;